/**
 *
 * Asynchronously loads the component for HomaPage
 *
 */
import { LoadingIndicator } from '@/components/loadingIndicator';
import React from 'react';
import { lazyLoad } from 'utils/loadable';

export const GovernancePage = lazyLoad(
  () => import('./index'),
  (module) => module.GovernancePage,
  { fallback: <LoadingIndicator fullPageHeight /> }
);
